import React from "react";
import Style from "./../../../assets/scss/custom.module.scss";
import { paymentReportType } from "../../../utils/data/data";
import CustomerPayDatePicker from "../../../components/datepicker/CustomerPayDatePicker";
import { overdueRE, paymentReport } from "../../../locales/en";
import PropTypes from "prop-types";
import { FaFilter, FaSpinner } from "react-icons/fa";

function PaymentHeader({
  initialStartDate,
  initialEndDate,
  selectedStatus,
  setSelectedStatus,
  handleEndDateChange,
  handleStartDateChange,
  loading,
  onFilter,
  handleSyncXero,
  isXeroSyncing
}) {
  return (
    <div className="row">
      <div className="col-xl-8 d-flex flex-wrap align-items-center">
        <ul
          className={`${Style.searchOptionWrap} d-flex flex-wrap align-items-center justify-content-xl-end`}
        >
          <li
            className={`${Style.datePicker31} my-1 d-flex align-items-center`}
          >
            <label className={`${Style.selectStatusLabel} me-1`}>
              {paymentReport?.startDate}
            </label>
            <CustomerPayDatePicker
              initialDate={initialStartDate}
              onDateChange={handleStartDateChange}
              className="start-date"
              loading={loading}
            />
          </li>
          <li
            className={`${Style.datePicker31} my-1 d-flex align-items-center`}
          >
            <label className={`${Style.selectStatusLabel} me-1`}>
              {paymentReport?.endDate}
            </label>
            <CustomerPayDatePicker
              initialDate={initialEndDate}
              onDateChange={handleEndDateChange}
              className="end-date"
              loading={loading}
            />
          </li>
          <li>
            <button
              className="btn btn-primary my-1"
              onClick={onFilter}
              disabled={loading}
            >
              {loading && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {overdueRE?.filter?.filterBtn} <FaFilter className="ms-1" />
            </button>
          </li>
          <li className="my-1 d-flex align-items-center">
            <label className={`${Style.selectStatusLabel} me-1`}>
              {paymentReport?.status}
            </label>
            <select
              name="filterReportType"
              className={`${Style.selectShowStatus} pe-5`}
              value={selectedStatus}
              disabled={loading}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              {paymentReportType.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.name}
                </option>
              ))}
            </select>
          </li>
        </ul>
      </div>
      <div className="col-xl-4 d-flex flex-wrap justify-content-xl-end">
        <ul
          className={`${Style.searchOptionWrap} d-flex flex-wrap align-items-xl-center justify-content-md-end`}
        >
          <li className="my-1">
            <button
              type="button"
              className={`btn btn-warning text-white d-inline-flex align-items-center justify-content-center spinDiv`}
              onClick={handleSyncXero}
              disabled={isXeroSyncing}
            >
              {isXeroSyncing
                ? paymentReport?.inProgress
                : paymentReport?.syncZero}
              {isXeroSyncing && (
                <span className="ms-2">
                  <FaSpinner className="spin" />
                </span>
              )}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

PaymentHeader.propTypes = {
  initialStartDate: PropTypes.instanceOf(Date),
  initialEndDate: PropTypes.instanceOf(Date),
  selectedStatus: PropTypes.string,
  setSelectedStatus: PropTypes.func,
  handleEndDateChange: PropTypes.func,
  handleStartDateChange: PropTypes.func,
  loading: PropTypes.bool,
  onFilter: PropTypes.func,
  handleSyncXero: PropTypes.func.isRequired,
  isXeroSyncing: PropTypes.bool.isRequired
};

export default PaymentHeader;
